"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapacidadeFornecedor = void 0;
var bson_1 = require("bson");
var CapacidadeFornecedor = /** @class */ (function () {
    function CapacidadeFornecedor(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.CD_FORN, CD_FORN = _c === void 0 ? '' : _c, _d = _a.CD_MATERIAL, CD_MATERIAL = _d === void 0 ? '' : _d, _e = _a.DT_VAL_INI, DT_VAL_INI = _e === void 0 ? '' : _e, _f = _a.DT_VAL_FIM, DT_VAL_FIM = _f === void 0 ? '' : _f, _g = _a.UN, UN = _g === void 0 ? '' : _g, _h = _a.CAPACIDADE, CAPACIDADE = _h === void 0 ? 0 : _h;
        this._id = _id;
        this.CD_FORN = CD_FORN;
        this.CD_MATERIAL = CD_MATERIAL;
        this.DT_VAL_INI = DT_VAL_INI;
        this.DT_VAL_FIM = DT_VAL_FIM;
        this.UN = UN;
        this.CAPACIDADE = CAPACIDADE;
    }
    return CapacidadeFornecedor;
}());
exports.CapacidadeFornecedor = CapacidadeFornecedor;
//# sourceMappingURL=CapacidadeFornecedor.js.map